import { render, staticRenderFns } from "./BudgetedCard.vue?vue&type=template&id=52656f48"
import script from "./BudgetedCard.vue?vue&type=script&lang=js"
export * from "./BudgetedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports